import { getInputDisplay } from '@strength/domain-workout';
import { useWorkoutContext } from '../../context/WorkoutContext';
import { BaseNumericInput } from './BaseNumericInput';
import { DeltaIndicator } from './DeltaIndicator';
import { BaseMetricInputProps } from './types';

export const UnitInput = ({
  workoutSetId,
  setMetric,
  exerciseMetric,
  originalSetMetric,
  libraryExerciseId,
  onEditSetMetric,
  disabled,
}: {
  libraryExerciseId: string;
} & BaseMetricInputProps) => {
  // Both resolved in WorkoutProvider: getMetric is org-scoped, getUnitsForMetric
  // orders units per the athlete's team.
  const { getMetric, getUnitsForMetric, selectedAthlete, applyBenchmarkData } =
    useWorkoutContext();
  const metric = getMetric(exerciseMetric.metricId);
  // Enables KPI resolution: a `%` on a KPI-mapped column resolves to this
  // athlete's target (SC-3844). A no-op for non-KPI columns (getInputDisplay
  // only resolves when the metric is KPI-mapped in applyBenchmarkData).
  const benchmarkData = {
    libraryExerciseId,
    profileId: selectedAthlete.id,
    metricId: exerciseMetric.metricId,
    applyBenchmarkData,
  };
  return (
    <BaseNumericInput
      display={getInputDisplay({
        metric,
        prescribedValue: originalSetMetric?.input,
        actualValue: setMetric?.input,
        benchmarkData,
      })}
      workoutSetId={workoutSetId}
      metricId={exerciseMetric.metricId}
      onEditSetMetric={(workoutSetId, value) =>
        onEditSetMetric(workoutSetId, value)
      }
      endAdornment={
        <DeltaIndicator
          metric={metric}
          prescribed={originalSetMetric?.input}
          actual={setMetric.input}
          benchmarkData={benchmarkData}
        />
      }
      // Collection input: the athlete records a reading, so the
      // prescription-only `%` is excluded even though the prescription shown
      // above may itself be a `%` (SC-4161).
      units={getUnitsForMetric(exerciseMetric.metricId, true)}
      disabled={disabled}
    />
  );
};
